import { SearchUsersFormValue } from '../../models';

export class SearchUsers {
  static readonly type = '[Agent] Search Users';
  constructor(public formValues: SearchUsersFormValue) {}
}

export class SignInAgent {
  static readonly type = '[Agent] Sign In Agent';
  constructor(public otp: string) {}
}
